import { Button, CircularProgress, Divider, Slide } from '@mui/material';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface SaveBarProps {
  open: boolean;
  saving: boolean;
  isValid: boolean;
  onCancel: () => void;
  onSave: () => void;
}

export function SaveBar({
  open,
  saving,
  isValid,
  onCancel,
  onSave,
}: Readonly<SaveBarProps>): ReactElement<SaveBarProps> {
  const [t] = useTranslation();

  return (
    <Slide direction="up" in={open} mountOnEnter unmountOnExit data-testid="save-bar">
      <div className="fixed inset-x-0 bottom-0 z-[1202] flex h-20 items-center justify-end gap-5 bg-white px-8 shadow-[4px_0_4px_rgba(0,_0,_0,_0.25)]">
        <Button variant="outlined" color="primary" onClick={onCancel} disabled={saving}>
          {t('SHARED_CANCEL')}
        </Button>
        <Divider sx={{ height: '40px' }} orientation="vertical" variant="middle" />
        <Button
          color="primary"
          onClick={onSave}
          disabled={!isValid || saving}
          startIcon={saving && <CircularProgress size={16} />}
        >
          {t('SHARED_SAVE')}
        </Button>
      </div>
    </Slide>
  );
}
